import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const InventoryDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Inventory Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Quantity</th>
                  <th>Description</th>
                  <th>Issue Date</th>
                  <th>Collect Date</th>
                </tr>
              </thead>
              <tbody>
                {employee?.inventoryDetails?.map((inventory) => (
                  <tr key={inventory.code}>
                    <td>{inventory.itemName}</td>
                    <td>{inventory.quantity}</td>
                    <td>{inventory.description}</td>
                    <td>
                      {inventory.dateOfIssue && format(new Date(inventory.dateOfIssue), "yyyy-MM-dd")}
                    </td>
                    <td>
                      {inventory?.dateOfCollection !== "" ||
                      inventory?.dateOfCollection !== null
                        ? format(
                            new Date(inventory.dateOfCollection),
                            "yyyy-MM-dd"
                          )
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

InventoryDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default InventoryDetails;
